export const packagePlans = [
  {
    id: 'starter',
    name: 'Starter',
    cta: 'Get Started',
    price: 14999,
    billingNote: 'One-time project fee',
    points: ['Single page site', 'Responsive layout', 'Contact form', 'Launch support'],
    details: [
      'Perfect for founders validating a new idea with a high-converting landing page.',
      'Includes basic SEO setup, speed optimization, and deployment support.',
      'Best fit when you need a clean online presence quickly.',
    ],
    timeline: '5-7 business days',
  },
  {
    id: 'cms-starter',
    name: 'CMS Starter',
    cta: 'Launch with CMS',
    price: 24999,
    billingNote: 'One-time project fee',
    points: ['5 page website', 'Admin panel', 'Editable banners/content', 'Basic media upload'],
    details: [
      'Best for businesses that want to update text, images, and sections without editing code.',
      'Includes a lightweight CMS setup for home, about, services, and contact pages.',
      'Ideal when your team needs easy day-to-day content control.',
    ],
    timeline: '7-10 business days',
  },
  {
    id: 'business',
    name: 'Business',
    cta: 'Choose Plan',
    price: 39999,
    billingNote: 'One-time project fee',
    popular: true,
    points: ['Multi-page site', 'UI animations', 'SEO foundation', 'Analytics + CRM setup'],
    details: [
      'Built for teams that need a complete website with conversion-focused flows.',
      'Includes service pages, about pages, lead funnels, and analytics wiring.',
      'Suitable for scaling businesses and client acquisition.',
    ],
    timeline: '12-16 business days',
  },
  {
    id: 'business-plus',
    name: 'Business Plus',
    cta: 'Scale My Website',
    price: 59999,
    billingNote: 'One-time project fee',
    points: ['Custom service pages', 'Blog or CMS module', 'Lead capture flows', 'Performance optimization'],
    details: [
      'Built for teams that need a stronger business website with reusable content management sections.',
      'Includes conversion-oriented landing pages, structured forms, and content editing flexibility.',
      'Suitable for growing companies focused on inbound leads and brand trust.',
    ],
    timeline: '14-20 business days',
  },
  {
    id: 'developer-retainer',
    name: 'Developer Retainer',
    cta: 'Book Developer',
    price: 74999,
    billingNote: 'Monthly engagement starting price',
    points: ['Dedicated developer', 'Weekly updates', 'Bug fixes + features', 'Technical support'],
    details: [
      'For businesses that need continuous improvements instead of a one-time website build.',
      'Includes hands-on development support, release planning, and maintenance coverage.',
      'A good fit for product teams and scaling service businesses.',
    ],
    timeline: 'Monthly sprint engagement',
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    cta: 'Talk to Sales',
    price: 89999,
    billingNote: 'Starting price, final quote after discovery',
    points: ['Custom platform', 'API integrations', 'Team dashboard', 'Priority support'],
    details: [
      'For complex systems requiring custom backend workflows and integrations.',
      'Includes architecture planning, milestone rollouts, and scale-readiness reviews.',
      'Ideal for organizations needing high ownership and long-term product support.',
    ],
    timeline: '4-8 weeks (scope dependent)',
  },
];

export const packagePlanMap = Object.fromEntries(packagePlans.map((plan) => [plan.id, plan]));
